import devLog from "./devLog";

const debug = (process.env.REACT_APP_DEBUG === "true")
    ? (...msg: any[]) => devLog(...msg)
    : () => {};

export default debug;
